module.exports = __webpack_public_path__ + "static/media/20.4abdf436.jpg";